import i18n from "@/i18n";

export const cancellationPolicyText = (availability) => {
  const descriptions = availability.cancelPolicies.penaltyDescriptions.map(
    ({ text }) =>
      `<li class="mb-2"><span class="text-main">♦</span> ${text}</li>`
  );

  return `<ul>${descriptions.join("")}</ul>`;
};

export const rateDetails = (availability) => {
  const parts = [productName(availability)];

  parts.push(
    availability.breakfast
      ? i18n.t("reservation.breakfast")
      : i18n.t("property.noMealIncluded")
  );

  parts.push(
    availability.cancelPolicies.nonRefundable
      ? i18n.t("reservation.nonRefundableRate")
      : i18n.t("reservation.refundableRate")
  );

  return parts.join(", ").replace(/, ([^-]+)$/, " - $1");
};

export const rateDetailsText = (availability) => {
  const items = [
    `<li class="mb-2"><span class="text-main">♦</span> ${rateDetails(
      availability
    )}</li>`,
  ];

  const { breakfast, room } = availability.additionalDetails;

  if (breakfast)
    items.push(
      `<li class="mb-2"><span class="text-main">♦</span> ${breakfast}</li>`
    );
  if (room)
    items.push(
      `<li class="mb-2"><span class="text-main">♦</span> ${room}</li>`
    );

  return `<ul>${items.join("")}</ul>`;
};

export const productName = (availability) => {
  return availability?.sellableUnit?.roomType || "";
};
